import React from 'react';
import ReactDOMServer from 'react-dom/server';
import glamorous from 'glamorous';
import {isMobile} from 'react-device-detect';

import { mixins } from '../../../../styles';

import TicketListRow from './TicketListRow';

const Container = glamorous.div(props => ({
  ...mixins.scroll,

  flex: 2,
  backgroundColor: '#fff',
  borderTop: `1px solid ${props.theme.default.lightest}`,

  fontSize: 12,

  '& .TicketListTitle': {
    padding: 8,
  },

  '& .relative': {
    position: 'relative',
  },

  '& .CuratedInfoBlock': {
    display: props.hasTicketAttributes ? undefined : 'none',
  },
}));

window.ticketOnMouseOver = (tgId) => {
  const ticket = window.Seatics.MapComponent.getTgFromId(tgId);
  window.Seatics.MapComponent.highlightTicket(ticket);
  if(!isMobile)
    window.Seatics.Tooltip.showTooltipForTg(ticket);
};

class TicketList extends React.PureComponent {
  static update(ticketListContainer, ticketDataSegmented, ticketListRowProps) {
    if (!ticketListContainer) {
      return;
    }

    const tableHtml = [
      '<div id="ticketTable" style="width:100%;">',
    ];

    window.onSelectTicket = ticketListRowProps.onSelectTicket;

    ticketDataSegmented.forEach((segment) => {
      if (!segment.tickets) {
        return;
      }

      if (segment.title) {
        tableHtml.push('<div><div class="TicketListTitle">' + segment.title + '</div></div>');
      }

      segment.tickets.forEach((ticketGrp) => {
        const row = ReactDOMServer.renderToStaticMarkup(
          <TicketListRow
            ticket={ticketGrp}
            {...ticketListRowProps}
          />
        );

        const onclick =
          `onclick="window.onSelectTicket(window.Seatics.MapComponent.getTgFromId(${ticketGrp.tgID}))"`;
        const onmouseover =
          `onmouseover="window.ticketOnMouseOver(${ticketGrp.tgID})"`;
        const rowWithClickHandler = row.replace('<div id="tgid', `<div ${onmouseover} ${onclick} id="tgid`);

        tableHtml.push(rowWithClickHandler);
      });

    });

    tableHtml.push('</div>');
    ticketListContainer.html(tableHtml.join(''));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedTicket !== this.props.selectedTicket) {
      if (nextProps.selectedTicket) {
        window.ticketOnMouseOver(nextProps.selectedTicket.tgID);
      } else {
        this.resetMap();
      }
    }
  }

  handleMouseOver = () => {
    this.isMouseOver = true;
  };

  handleMouseOut = (e) => {
    if (!this.props.isReady) {
      return null;
    }

    const { clientX, clientY } = e;
    const { top, left, width, height } = e.currentTarget.getBoundingClientRect();

    const withinWidth = (clientX >= left) && ( clientX <= (width + left) );
    const withinHeight = (clientY >= top) && ( clientY <= (height + top) );

    this.isMouseOver = withinWidth && withinHeight;

    if (!this.isMouseOver && !this.props.selectedTicket) {
      this.resetMap();
    }
  };

  resetMap() {
    const { Seatics } = window;

    if (Seatics) {
      if (Seatics.MapComponent && Seatics.MapComponent.highlightTicket) {
        Seatics.MapComponent.highlightTicket({});
      }

      if (Seatics.Tooltip && Seatics.Tooltip.hide) {
        Seatics.Tooltip.hide();
      }
    }
  }

  render() {
    return (
      <Container
        id="ticketsListDiv"
        onMouseOut={this.handleMouseOut}
        hasTicketAttributes={this.props.hasTicketAttributes}
      />
    );
  }
}

export default TicketList;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/TicketList.js